import { buildFeedbackBody, type NewFeedback } from "@heraion/shared";
import type { DurableWriteResult } from "@heraion/ui";

import { durableWrite } from "./durableWrite";

// The web sender of the shared feedback form: the envelope is web's (surface,
// build version, browser UA as the device tag); the body shape is the shared
// builder's. Web has no last-screen tracker, so none is sent (optional field).
export function submitWebFeedback(
  body: Pick<NewFeedback, "kind" | "body">,
): Promise<DurableWriteResult> {
  return durableWrite({
    method: "POST",
    path: "/api/feedback",
    body: buildFeedbackBody(body, {
      surface: "web",
      appVersion: __APP_VERSION__,
      device: navigator.userAgent.slice(0, 128),
    }),
  });
}
